/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestUsersFavorites_requestDeleteUserFavorite } from '../models/api_requestUsersFavorites_requestDeleteUserFavorite';
import type { api_requestUsersFavorites_requestListUserFavorites } from '../models/api_requestUsersFavorites_requestListUserFavorites';
import type { api_requestUsersFavorites_requestSaveUserFavorite } from '../models/api_requestUsersFavorites_requestSaveUserFavorite';
import type { api_requestUsersFavorites_responseDeleteUserFavorite } from '../models/api_requestUsersFavorites_responseDeleteUserFavorite';
import type { api_requestUsersFavorites_responseListUserFavorites } from '../models/api_requestUsersFavorites_responseListUserFavorites';
import type { api_requestUsersFavorites_responseSaveUserFavorite } from '../models/api_requestUsersFavorites_responseSaveUserFavorite';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestUserFavoriteService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Delete User Favorite Office
     * Deletes a user's favorite office by ID
     * @returns api_requestUsersFavorites_responseDeleteUserFavorite Successful response
     * @throws ApiError
     */
    public postRequestUserFavoritesDelete({
        body,
    }: {
        /**
         * requestDeleteUserFavorite
         */
        body: api_requestUsersFavorites_requestDeleteUserFavorite,
    }): CancelablePromise<api_requestUsersFavorites_responseDeleteUserFavorite> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_favorites/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List User Favorite Offices
     * Lists user's favorite offices optionally sorted by creation date
     * @returns api_requestUsersFavorites_responseListUserFavorites Successful response
     * @throws ApiError
     */
    public postRequestUserFavoritesList({
        body,
    }: {
        /**
         * requestListUserFavorites
         */
        body: api_requestUsersFavorites_requestListUserFavorites,
    }): CancelablePromise<api_requestUsersFavorites_responseListUserFavorites> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_favorites/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save User Favorite Office
     * Save a user's favorite office
     * @returns api_requestUsersFavorites_responseSaveUserFavorite Successful response
     * @throws ApiError
     */
    public postRequestUserFavoritesSave({
        body,
    }: {
        /**
         * requestSaveUserFavorite
         */
        body: api_requestUsersFavorites_requestSaveUserFavorite,
    }): CancelablePromise<api_requestUsersFavorites_responseSaveUserFavorite> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_favorites/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
